import React, { useState, useEffect, useRef } from 'react'
import { baseUrl } from 'utils/parseDomain'
import { Link, Arrow, HelpIcon } from './common/createStyledElement'
import heroStyles from 'styles/hero.module.scss'
import 'styles/helpLink.scss'

function HelpLink(props) {
  const [helpToggle, onHelpToggle] = useState(false)
  const toggleElement = useRef(null)

  useEffect(
    () => {
      const clickHandler = e => {
        if (!toggleElement.current) return
        if (!toggleElement.current.contains(e.target)) onHelpToggle(!helpToggle)
      }
      document.addEventListener('click', clickHandler)
      return () => document.removeEventListener('click', clickHandler)
    },
    [helpToggle]
  )

  return (
    <>
      <Link
        data-testid="help_link"
        href="javascript:void(0)"
        className={heroStyles.help}
        colorCode={props.topNavRightColor}
        onClick={() => onHelpToggle(!helpToggle)}
      >
        <HelpIcon colorCode={props.topNavRightColor} />
        Help
        <Arrow colorCode={props.topNavRightColor} />
      </Link>
      {helpToggle ? (
        <div ref={toggleElement} className="helpBoxWrap">
          <div className="helpBoxLeft">
            <div className="helpContryContact">India - 1860-200-3456</div>
            <div className="helpRegionalText">
              For regional offices{' '}
              <a
                href={`${baseUrl}/shaadi-info/index/contact-us`}
                target="_blank"
                rel="noopener noreferrer"
              >
                click here
              </a>
            </div>
            <div className="helpAvailInfo">
              We are available between 10 am to 7pm.
            </div>
            <div className="getInstantHelp">
              To get instant help{' '}
              <a
                href="https://help.shaadi.com/hc/en-us"
                target="_blank"
                rel="noopener noreferrer"
              >
                click here
              </a>
            </div>
          </div>
          <div className="helpBoxRight">
            <div>
              <a
                href="https://help.shaadi.com/hc/en-us"
                target="_blank"
                rel="noopener noreferrer"
              >
                Help Desk
              </a>
            </div>
            <div>
              <a
                href="https://help.shaadi.com/hc/en-us/articles/203572542-Be-Safe-Online"
                target="_blank"
                rel="noopener noreferrer"
              >
                Be Safe Online
              </a>
            </div>
          </div>
        </div>
      ) : null}
    </>
  )
}

export default HelpLink
